<template>
  <section :id="id" class="section-card" :aria-labelledby="headingId" :aria-busy="loading || undefined">
    <header class="section-card-header">
      <component :is="headingTag" :id="headingId" class="section-card-title">
        {{ title }}<template v-if="subtitle"> — {{ subtitle }}</template>
      </component>
    </header>
    <AppProgressLinear v-if="loading" />
    <div class="section-card-body">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppProgressLinear from '../AppProgressLinear/AppProgressLinear.vue'

const props = defineProps<{
  title: string
  subtitle?: string
  id?: string
  headingTag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  loading?: boolean
}>()

const headingId = computed(() => (props.id ? `${props.id}-heading` : undefined))
const headingTag = computed(() => props.headingTag ?? 'h2')
</script>

<style lang="scss" scoped>
.section-card {
  scroll-margin-top: var(--section-card-scroll-margin, 0px);
  background-color: var(--color-canvas-default);
  border: 1px solid var(--color-border-default);
  border-radius: 6px;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 16px;
  background-color: var(--color-canvas-muted);
  border-bottom: 1px solid var(--color-border-default);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.section-card-title {
  margin: 0;
  font: inherit;
  font-weight: 600;
  font-size: 16px;
}

.section-card-body {
  padding: 16px;
}
</style>
